<template>
  <div>
    <div class="flex-end">
      <Filters />
    </div>
    <h2>
      Number of videos: <span>{{ videos.total }}</span>
    </h2>
    <el-table
      :data="videos.data"
      :default-sort="{ prop: order_column, order: order_type }"
      @sort-change="sort"
      class="w100"
      stripe
      v-loading="loading"
    >
      <el-table-column label="Video" prop="title" width="500" sortable>
        <template slot-scope="props">
          <a class="link pointer" target="_blank" @click="playVideo(props.row)">
            {{ props.row.title }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="Video ID" prop="videoId" width="500" sortable>
        <template slot-scope="props">
          <a class="link pointer" target="_blank" >
            {{ props.row.video }}
          </a>
        </template>
      </el-table-column>
      <el-table-column label="E-mail" prop="email" sortable></el-table-column>
      <el-table-column label="Published" prop="published" sortable>
        <template slot-scope="props">
          {{ props.row.published | date }}
        </template>
      </el-table-column>
      <el-table-column
        label="Category"
        prop="category"
        sortable
      ></el-table-column>
      <el-table-column
        label="Subscribers"
        prop="subscribers"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="Views"
        prop="views"
        sortable
        :formatter="commaNumTable"
      ></el-table-column>
      <el-table-column
        label="No. Tracks"
        prop="track"
        sortable
      ></el-table-column>
      <el-table-column label="Tier" prop="tier" sortable="custom">
        <template slot-scope="props">
          <el-tag :type="tierType(props.row.tier)">
            {{ tierName(props.row.tier) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Show charts">
            <el-button
              type="success"
              circle
              size="small"
              icon="el-icon-s-data"
              @click="readVideoChartData(props.row)"
            ></el-button>
          </el-tooltip>
          <el-tooltip class="ml10" content="Show tracks">
            <el-popover placement="left" width="400" trigger="click">
              <el-table
                :data="tracks"
                class="w100"
                stripe
                v-loading="tracks_loading"
              >
                <el-table-column prop="artist" label="Artist"></el-table-column>
                <el-table-column prop="title" label="Track"></el-table-column>
              </el-table>
              <el-button
                slot="reference"
                type="success"
                circle
                size="small"
                icon="el-icon-headset"
                @click="readVideoTracks(props.row.video)"
              ></el-button>
            </el-popover>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="float-right"
      background
      @size-change="sizeChange"
      @current-change="currentChange"
      :current-page.sync="videos.current_page"
      :page-sizes="[5, 10, 25, 50, 100, 500]"
      :page-size="page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="videos.total"
    ></el-pagination>
    <el-dialog
      :title="channel_video_chart_name"
      :visible.sync="dialogVisibleVideoCharts"
      width="75%"
      top="7vh"
    >
      <el-tabs :tab-position="subTabsPosition">
        <el-col :span="24">
          <el-divider content-position="left">Views</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="video_chart_views"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="video_chart_views_daily"
            :options="LineChartSett"
          />
        </el-col>
        <el-col :span="24">
          <el-divider content-position="left">Subscribers</el-divider>
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="video_chart_subscribers"
            :options="LineChartSett"
          />
        </el-col>
        <el-col id="vid" :span="24" :lg="12">
          <GChart
            type="LineChart"
            :data="video_chart_subscribers_daily"
            :options="LineChartSett"
          />
        </el-col>
      </el-tabs>
    </el-dialog>
    <el-dialog
      :title="channel_video_name"
      :visible.sync="dialogVisibleVideo"
      width="60%"
      top="7vh"
      class="text-center"
    >
      <iframe width="850" height="550" :src="video_link"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'
import Filters from './Filters'

export default {
  components: {
    GChart,
    Filters
  },

  data() {
    return {
      channel_video_chart_name: '',
      dialogVisibleVideo: false,
      subTabsPosition: 'top',
      active: 'videos_data',
      video_link: '',
      channel_video_name: '',
      dialogVisibleVideoCharts: false
    }
  },

  computed: {
    ...mapState('reportsVideos', [
      'loading',
      'tracks_loading',
      'videos',
      'tracks',
      'date_range',
      'page_size',
      'order_column',
      'order_type',
      'LineChartSett'
    ]),

    ...mapGetters('auth', ['admin_role']),
    ...mapGetters('reportsVideos', [
      'video_chart_views',
      'video_chart_views_daily',
      'video_chart_subscribers',
      'video_chart_subscribers_daily'
    ])
  },

  methods: {
    ...mapMutations('reportsVideos', [
      'setPage',
      'setPageSize',
      'setOrdering',
      'setDateRange'
    ]),
    ...mapActions('reportsVideos', [
      'readVideos',
      'readVideoChart',
      'readVideoTracks'
    ]),

    readVideoChartData(data) {
      this.dialogVisibleVideoCharts = true
      this.channel_video_chart_name = `${data.category} - ${data.title}`
      this.readVideoChart({
        id: data.video,
        start: this.date_range[0],
        end: this.date_range[1]
      })
    },

    playVideo(data) {
      this.dialogVisibleVideo = true
      this.channel_video_name = `${data.title}`
      this.video_link = `https://www.youtube.com/embed/${data.video}`
    },

    sizeChange(page_size) {
      this.setPageSize(page_size)
      this.readVideos()
    },

    currentChange(page) {
      this.setPage(page)
      this.readVideos()
    },

    sort(d) {
      this.setOrdering({
        column: d.prop,
        type: this.ascDesc(d.order)
      })
      this.readVideos()
    }
  }
}
</script>

<style scoped>
.text-center {
  text-align: center;
}

h2 {
  color: #3e3e3e;
  font-size: 1.6rem;
  text-align: left;
  font-weight: 100;
  margin: 1.2rem 0.5rem 2rem;
}

span {
  font-weight: 700;
}
</style>
